import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-linear-list-item',
  templateUrl: 'linear-list-item.component.html',
  styleUrls: ['linear-list-item.component.scss'],
  host: {
    'role': 'row'
  }
})
export class LinearListItemComponent {
}
